// extracted by mini-css-extract-plugin
export default {"header":"Header_header_vgT6o","content":"Header_content_ux5u9","logo":"Header_logo_OgKqP","textLogo":"Header_textLogo_JT1Ob","contacts":"Header_contacts_eeaVn"};